import { graphql, useFragment } from 'react-relay';
import { EventPanelList } from './EventPanelList';
import type { EventPanel$key } from './__generated__/EventPanel.graphql';
import { Box, Flex, Text, useTheme } from '@vitvio/design-system';
import { useStyledScrollBarProps } from '@vitvio/shared-components';

const fragment = graphql`
  fragment EventPanel on Job {
    id
    eventTypes {
      id
      name
      nameI18nKey
      category
      order
      enabled
      blockedReason
    }
    events(first: 20) {
      ...EventPanelListFragment_event
    }
  }
`;

interface Props {
  surgeryDataRef: EventPanel$key | undefined;
  turnoverDataRef: EventPanel$key | undefined;
}

export function EventPanel({ surgeryDataRef, turnoverDataRef }: Props) {
  const surgeryData = useFragment(fragment, surgeryDataRef);
  const turnoverData = useFragment(fragment, turnoverDataRef);
  const { getColor, getSpacing } = useTheme();

  const styledScrollBarProps = useStyledScrollBarProps();
  return (
    <Flex flexDir={'column'} h={'100%'} overflow={'hidden'}>
      <Box bg={getColor('bg')} p={getSpacing('2')} mb={getSpacing('3')}>
        <Text fontWeight={'semibold'} path="common:events.logSurgeryEvents" />
      </Box>
      <Flex
        flexDir={'column'}
        gap={2}
        overflowY={'auto'}
        sx={{
          ...styledScrollBarProps,
          pr: '4px',
        }}
      >
        <EventPanelList
          eventTypes={surgeryData?.eventTypes || undefined}
          eventFragmentRef={surgeryData?.events || undefined}
          jobId={surgeryData?.id || ''}
          jobType={'SURGERY'}
        />
        <EventPanelList
          eventTypes={turnoverData?.eventTypes || undefined}
          eventFragmentRef={turnoverData?.events || undefined}
          jobId={turnoverData?.id || ''}
          jobType={'TURNOVER'}
        />
      </Flex>
    </Flex>
  );
}
